import {socket} from '../EntryShared.ts'
import {ShuffleAction} from '@colonist/lobby-types'
import {ClientMessageSubType} from '@colonist/types'
import {NetworkEnums} from '../../../../shared/GameEnums.ts'
import SendShuffleActionData = NetworkEnums.SendShuffleActionData

export class SocketShuffleSend {
    private static send(action: ShuffleAction, data: unknown) {
        const actionDataToSend: SendShuffleActionData = {
            action: action,
            payload: data,
        }
        socket.controller.sender.sendToServerType(ClientMessageSubType.ShuffleAction, 'lobby', actionDataToSend)
    }

    static requestShuffleQueueData() {
        this.send(ShuffleAction.GetShuffleQueueData, undefined)
    }
}

